import React from "react";
import img3 from './images/Nachos.jpeg';

export default function Nachos() {
    return(
        <div>
        <img src={img3} alt="People Eating" />
        </div>
    );
}